// Helper function to get the correct image URL
// Handles both local uploads (/api/uploads/...) and external URLs (https://...)

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getImageUrl = (url) => {
  if (!url) return null;
  
  // If it's already a full URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a local upload path, prepend the backend URL
  if (url.startsWith('/api/uploads/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Fallback - assume it's a relative path
  return `${BACKEND_URL}${url}`;
};

export default getImageUrl;
